export interface SortableSeason {
  order?: number | null;
  startDate?: string | null;
  name?: string;
}

const getSeasonYearFromName = (name?: string): number => {
  if (!name) return 0;
  const match = name.match(/(\d{4})\/\d{2}/);
  return match ? parseInt(match[1], 10) : 0;
};

/** Match server season ordering: competition tier, then newest season first. */
export const sortSeasonsByDisplayOrder = <T extends SortableSeason>(seasons: T[]): T[] =>
  [...seasons].sort((a, b) => {
    const orderDiff = (a.order ?? 999) - (b.order ?? 999);
    if (orderDiff !== 0) return orderDiff;

    const aStart = a.startDate ? new Date(a.startDate).getTime() : 0;
    const bStart = b.startDate ? new Date(b.startDate).getTime() : 0;
    if (aStart !== bStart) return bStart - aStart;

    return getSeasonYearFromName(b.name) - getSeasonYearFromName(a.name);
  });

export const getDefaultSeasonId = <T extends SortableSeason & { id: string }>(
  seasons: T[]
): string | null => {
  const sorted = sortSeasonsByDisplayOrder(seasons);
  return sorted[0]?.id ?? null;
};
